import React from "react";

export const fmtINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(Number(n) || 0);

export function KpiTile({ label, value, accent, sub }) {
  const palette = {
    green: "bg-emerald-50 border-emerald-200 text-emerald-900",
    amber: "bg-amber-50 border-amber-200 text-amber-900",
    red: "bg-red-50 border-red-200 text-red-900",
    blue: "bg-sky-50 border-sky-200 text-sky-900",
  };
  return (
    <div className={`rounded-md border p-4 ${accent ? palette[accent] : "bg-white border-zinc-200"}`}>
      <div className="label-overline">{label}</div>
      <div className="font-display text-2xl font-black tracking-tight mt-1">{value}</div>
      {sub && <div className="text-[11px] text-zinc-500 mt-1">{sub}</div>}
    </div>
  );
}

export function BreakdownTable({ title, rows, colKey, colLabel }) {
  if (!rows || rows.length === 0) {
    return (
      <div className="bg-white border border-zinc-200 rounded-md p-6">
        <div className="label-overline">{title}</div>
        <div className="py-4 text-center text-xs text-zinc-400">No data for this period.</div>
      </div>
    );
  }
  return (
    <div className="bg-white border border-zinc-200 rounded-md overflow-x-auto">
      <div className="px-4 pt-4">
        <div className="label-overline">{title}</div>
      </div>
      <table className="w-full text-sm mt-2 min-w-[520px]">
        <thead className="bg-zinc-50 border-y border-zinc-200">
          <tr className="text-left text-zinc-500 uppercase text-[10px] tracking-widest">
            <th className="py-2 px-4">{colLabel}</th>
            <th className="py-2 px-3 text-right">Headcount</th>
            <th className="py-2 px-3 text-right">Gross</th>
            <th className="py-2 px-3 text-right">Net</th>
            <th className="py-2 px-3 text-right">OT hrs</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r[colKey] || r.department} className="border-b border-zinc-100 last:border-0">
              <td className="py-2 px-4 font-medium">{r[colKey] || r.department}</td>
              <td className="py-2 px-3 text-right font-mono">{r.headcount}</td>
              <td className="py-2 px-3 text-right font-mono text-emerald-700">{fmtINR(r.gross)}</td>
              <td className="py-2 px-3 text-right font-mono text-zinc-700">{fmtINR(r.net)}</td>
              <td className="py-2 px-3 text-right font-mono text-zinc-600">{r.ot_hours}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function PeriodAndPropertyFilter({ periodMonth, setPeriodMonth, propertyId, setPropertyId, properties }) {
  return (
    <div className="flex gap-2 flex-wrap items-end">
      <div>
        <div className="label-overline">Period</div>
        <input
          type="month"
          value={periodMonth}
          onChange={(e) => setPeriodMonth(e.target.value)}
          className="border border-zinc-200 rounded-md px-3 py-1.5 text-sm bg-white"
          data-testid="dashboard-period"
        />
      </div>
      {properties?.length > 1 && (
        <div>
          <div className="label-overline">Property</div>
          <select
            value={propertyId}
            onChange={(e) => setPropertyId(e.target.value)}
            className="border border-zinc-200 rounded-md px-3 py-1.5 text-sm bg-white"
            data-testid="dashboard-property"
          >
            <option value="">All properties</option>
            {properties.map((p) => (
              <option key={p.id} value={p.id}>{p.name}</option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}

export function ScopeBadge({ propertyId, properties }) {
  const name = propertyId
    ? (properties?.find((p) => p.id === propertyId)?.name || "Selected property")
    : "All properties";
  return (
    <div className="inline-flex items-center gap-1.5 text-[11px] text-zinc-600 bg-zinc-100 border border-zinc-200 rounded-full px-2.5 py-0.5">
      <span className="font-semibold uppercase tracking-wider text-[9px]">Scope</span>
      <span className="font-medium">{name}</span>
    </div>
  );
}
